export default {
  home: {
    vi: 'Trang chủ',
    en: 'Homepage'
  }
};
